angular.module('controllers').controller('menuController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter',
	function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter) {
		$rootScope.path = '/menu';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'menu';
		$scope.pathTemplate = 'app/menus';
		$scope.title = 'Meniu';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.defaultItem = 10;
        $rootScope.typeId = 'id';
		$scope.search.order = 'asc';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'menu_title':{'label':'Titlu', 'filter':1, 'filterType':'input'},
			//'menu_description':{'label':'Descriere', 'filter':1, 'filterType':'input'},
			'menu_parent_id':{'label':'Parinte', 'filter':1, 'filterType':'select'},
			'menu_type':{'label':'Tip meniu', 'filter':1, 'filterType':'select'},
			'menu_state':{'label':'Legatura', 'filter':1, 'filterType':'input'},
			//'menu_icon':{'label':'Icon', 'filter':1, 'filterType':'input'},
			'menu_order':{'label':'Ordonare', 'filter':0, 'filterType':'input'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];

		$scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'menu_title';
		$scope.additionals['sections'] = [
			{'id':'link', 'value' : 'link'},
			{'id':'toggle', 'value' : 'toggle'}
		];

		/* get dependent fields */
		$scope.getDependedFields = function () {
			Crud.getDependedFields($scope.path)
				.success(function (data) {

					$scope.getCategoryHierarchy = $scope.additionals['makeDropDown'](data.parents, 'menu_title');
					$scope.additionals['parents'] = $scope.getCategoryHierarchy;
					$scope.columns.menu_parent_id.options =[{'id': 0, 'value': '--root--'}];
					angular.forEach($scope.getCategoryHierarchy, function (item, key) {
						$scope.columns.menu_parent_id.options.push({id:item.id, value:item.menu_title});
					});

					$scope.columns.menu_type.options = $scope.additionals['sections'];

				});
		}

		$scope.additionals['searchTerm'];
		$scope.additionals['clearSearchTerm'] = function() {
			$scope.additionals['searchTerm'] = '';
		};
		$scope.additionals['onSearchChange'] = function(ev) {
			ev.stopPropagation();
		};

		/*$scope.showMenu = function (model) {
			return function(value, index, array) {
				return value['id'] == 0 || value['menu_section_id'] == model.menu_section_id;
			}
		}
*/
		$scope.additionals['functionResult'] = function(ev, data) {
			$scope.getCategoryHierarchy = $scope.additionals['makeDropDown'](data.parents, 'menu_title');
			$scope.additionals['parents'] = $scope.getCategoryHierarchy;

			$scope.columns.menu_parent_id.options =[{'id': 0, 'value': '--root--'}];
			angular.forEach($scope.getCategoryHierarchy, function (item, key) {
				$scope.columns.menu_parent_id.options.push({id:item.id, value:item.menu_title});
			});

			/*var no_pages = Math.ceil(($scope.total - 1) / $scope.state.itemsPerPage);
			if ($scope.state.page > no_pages) {
				$scope.state.page = no_pages;
			}
			$scope.getPaginateModel($rootScope.path, $scope.state.page, $scope.state.itemsPerPage);*/

			$rootScope.initMenu();

		}

		/* change order down */
		$scope.changeOrderDown = function (model) {
			$scope.additionals['invalid'] = '';
			var datas = '';
			$scope.models = $filter('orderBy')($scope.models, $scope.sortType, $scope.sortReverse);

			$scope.sortType = '';
			$scope.sortReverse = false;

			var position = $scope.models.map(function (e) {
				return e.id;
			}).indexOf(model[$rootScope.typeId]);

			datas = $scope.models.slice(position, position+2);
			var aux = datas[1];
			datas[1] = datas[0];
			datas[0] = aux;

			$scope.models[position] = datas[0];
			$scope.models[position+1] = datas[1];

			var auxOrder = $scope.models[position+1].menu_order;
			$scope.models[position+1].menu_order = $scope.models[position].menu_order;
			$scope.models[position].menu_order = auxOrder;

			var post = {};
			post['modelFirst'] = $scope.models[position];
			post['modelSecond'] = $scope.models[position+1];
			post['route'] = 'changeOrder';

			Crud.post($scope.additionals['content_type'], post, $scope.path+'/changeOrder')
				.success(function (data) {
					if (!angular.isUndefined(data.invalid)) {
						$scope.additionals['invalid'] = data.invalid;
					} else {
						$rootScope.initMenu();
					}
				});
		}

		/* change order up */
		$scope.changeOrderUp = function (model) {
			$scope.additionals['invalid'] = '';
			var datas = '';
			$scope.models = $filter('orderBy')($scope.models, $scope.sortType, $scope.sortReverse);

			$scope.sortType = '';
			$scope.sortReverse = false;

			var position = $scope.models.map(function (e) {
				return e.id;
			}).indexOf(model[$rootScope.typeId]);

			datas = $scope.models.slice(position-1, position+1);
			var aux = datas[1];
			datas[1] = datas[0];
			datas[0] = aux;

			$scope.models[position-1] = datas[0];
			$scope.models[position] = datas[1];

			var auxOrder = $scope.models[position-1].menu_order;
			$scope.models[position-1].menu_order = $scope.models[position].menu_order;
			$scope.models[position].menu_order = auxOrder;

			var post = {};
			post['modelFirst'] = $scope.models[position];
			post['modelSecond'] = $scope.models[position-1];
			post['route'] = 'changeOrder';

			Crud.post($scope.additionals['content_type'], post, $scope.path+'/changeOrder')
				.success(function (data) {
					if (!angular.isUndefined(data.invalid)) {
						$scope.additionals['invalid'] = data.invalid;
					} else {
						$rootScope.initMenu();
					}

				});
		}



	}]
)
